import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { Card, CardBody, Row, Col, Button } from "reactstrap";
import CardBasic from "../../../components/Cards/Basic";
import PageHeading from "../../../components/PageHeading";
import ModalAlamat from "../../../components/Modal/ModalAlamat";
import * as actions from "../../../redux/actions";
import {
  createAccountAddress,
  deleteAccountAddress,
  updateAccountAddress,
} from "../../../redux/actions/account";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";

const Alamat = ({ data }) => {
  const { name, title, parent } = data;
  const { address } = useSelector((state) => state.account);
  const [modal, setModal] = useState(false);
  const [selectedSearchAddress, setSelectedSearchAddress] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const { register, handleSubmit, reset, setValue, watch, formState: { errors } } = useForm({
    nama: "",
    label: "",
    alamat: "",
    kecamatan: "",
    kota: "",
    phone: "",
    kode_pos: "",
    public_id: "",
    provinsi: "",
    kelurahan: "",
    kelurahan_id: "",
    is_default: false
  });
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      actions.setMenuActive({ menuActive: parent || name, subMenuActive: name })
    );
  }, [dispatch, name, parent]);

  const submit = (data, action) => {
    if (action === "delete") {
      dispatch(deleteAccountAddress(data.public_id));
      setModal(false);
      setSelectedRow(null);
      setSelectedSearchAddress(null);
      return;
    }

    // if (!data.id_alamat_domestic) {
    //   toast.error("Alamat belum dilengkapi");
    //   return;
    // }

    if (data.public_id && data.public_id !== "") {
      dispatch(updateAccountAddress(data.public_id, data));
    } else {
      dispatch(createAccountAddress(data));
    }
    setModal(false);
    setSelectedRow(null);
    // setSelectedSearchAddress(null);
  };

  const handleClick = (data) => {
    setModal(true);
    setSelectedRow(data);
  };




  return (
    <div>
      <PageHeading title={title} />

      <CardBasic title="Alamat yang sudah tersimpan">
        <div className="d-flex justify-content-end mb-3">
          <Button
            color="primary"
            onClick={() => {
              setModal(true);
              setSelectedRow(null);
              reset({
                nama: "",
                label: "",
                alamat: "",
                kecamatan: "",
                kota: "",
                phone: "",
                kode_pos: "",
                public_id: "",
                provinsi: "",
                kelurahan: "",
                kelurahan_id: "",
                is_default: false
              });
            }}
          >
            Tambah Alamat
          </Button>
        </div>

        <ModalAlamat
          toggle={() => setModal(!modal)}
          modal={modal}
          data={selectedRow}
          submit={submit}
        />

        <Row className="g-3">
          {address?.rows?.map((data, key) => (
            <Col md={6} lg={4} key={key}>
              <Card
                className="h-100 shadow-sm mt-2"

              >
                <CardBody>
                  <div className="mb-2 clearfix">

                    {data?.is_default && (
                      <span className="badge badge-primary px-3 py-1 text-white ml-2">Default</span>
                    )}

                    <button
                      className="btn btn-link text-secondary p-0 float-right"
                      onClick={() => handleClick(data)}
                      title="Edit"
                      style={{ fontSize: "1rem", lineHeight: 1 }}
                    >
                      <i className="fas fa-edit"></i>
                    </button>
                  </div>


                  <strong>{data.label}</strong>
                  <div className="mb-1">
                    <small className="text-muted">Nama Penerima:</small>
                    <div>{data.nama}</div>
                  </div>
                  <div className="mb-1">
                    <small className="text-muted">Nomor Telepon:</small>
                    <div>{data.phone}</div>
                  </div>
                  <div className="mb-1">
                    <small className="text-muted">Kota:</small>
                    <div>{data.kota}</div>
                  </div>
                  <div className="mt-2">
                    <small className="text-muted">Alamat Lengkap:</small>
                    <div>
                      {`${data.alamat}, Kec. ${data.kecamatan}, Kab/Kota. ${data.kota}, Prov. ${data.provinsi}, Kode Pos ${data.kode_pos}`}
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          ))}
        </Row>
      </CardBasic>
    </div>
  );
};

Alamat.propTypes = {
  data: PropTypes.shape({
    name: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    parent: PropTypes.string,
  }).isRequired,
};

export default Alamat;
